/**
 * Site theme presets. Each theme maps to CSS custom properties applied on :root.
 * Components can opt-in via `style={{ background: "var(--color-bg)" }}` or
 * Tailwind arbitrary values like `bg-[var(--color-bg)]`.
 */
export const THEMES = {
  /**
   * Four dark themes only. The previous "default" (white #ffffff light) theme
   * was removed because many of our SaaS/tool components were styled purely for
   * dark mode and produced unreadable light-text-on-light-bg combos in forms,
   * modals and product subpages. Keeping the app dark-only guarantees consistent
   * contrast everywhere. If we ever want light mode back, it must be designed
   * holistically — not as a global color swap.
   */
  cyberpunk: {
    label: "Cyberpunk",
    description: "Fialovo-cyan dark tech. Premium SaaS vibe, ako PulseAI Engine™ showcase.",
    preview: ["#0a0a0a", "#a855f7", "#67e8f9"],
    vars: {
      "--color-bg": "#0a0a0a",
      "--color-surface": "#1a1a1f",
      "--color-surface-alt": "#0e0a1e",
      "--color-primary": "#a855f7",
      "--color-accent": "#67e8f9",
      "--color-text": "#ffffff",
      "--color-text-muted": "#c6c6da",
      "--color-border": "#2a2a35",
      "--theme-is-dark": "1",
    },
  },
  minimal: {
    label: "Minimal",
    description: "Tmavo-šedá, čistá. Neutrálny B2B look bez akcentov.",
    preview: ["#0f0f12", "#60a5fa", "#a1a1aa"],
    vars: {
      "--color-bg": "#0f0f12",
      "--color-surface": "#17171c",
      "--color-surface-alt": "#1e1e24",
      "--color-primary": "#60a5fa",
      "--color-accent": "#a78bfa",
      "--color-text": "#fafafa",
      "--color-text-muted": "#a1a1aa",
      "--color-border": "#2a2a33",
      "--theme-is-dark": "1",
    },
  },
  matrix: {
    label: "Matrix",
    description: "Zelený terminal aesthetic. Hacker culture, developer-friendly.",
    preview: ["#000000", "#00ff41", "#00b32b"],
    vars: {
      "--color-bg": "#000000",
      "--color-surface": "#0a120a",
      "--color-surface-alt": "#050505",
      "--color-primary": "#00ff41",
      "--color-accent": "#00b32b",
      "--color-text": "#c8f7c5",
      "--color-text-muted": "#6b9669",
      "--color-border": "#1a3a1a",
      "--theme-is-dark": "1",
    },
  },
  ocean: {
    label: "Ocean",
    description: "Modro-tyrkysová profesionálna. Clean, ako Linear × Stripe.",
    preview: ["#0a1a2e", "#00d4ff", "#0077b6"],
    vars: {
      "--color-bg": "#0a1a2e",
      "--color-surface": "#102a43",
      "--color-surface-alt": "#0a1f33",
      "--color-primary": "#00d4ff",
      "--color-accent": "#0077b6",
      "--color-text": "#e0f4ff",
      "--color-text-muted": "#8db4cc",
      "--color-border": "#1e3a52",
      "--theme-is-dark": "1",
    },
  },
};

export const DEFAULT_CUSTOM = {
  primary: "#8b5cf6",
  accent: "#06b6d4",
  bg: "#0a0a0a",
  surface: "#141414",
  surface_alt: "#0e0a1e",
  text: "#ffffff",
  text_muted: "#a1a1aa",
  border: "#27272a",
};

export const customToVars = (c) => ({
  "--color-bg": c.bg,
  "--color-surface": c.surface,
  "--color-surface-alt": c.surface_alt,
  "--color-primary": c.primary,
  "--color-accent": c.accent,
  "--color-text": c.text,
  "--color-text-muted": c.text_muted,
  "--color-border": c.border,
  "--theme-is-dark": "1",
});

export const applyThemeVars = (vars) => {
  const root = document.documentElement;
  Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
};

export const setBodyThemeAttr = (name) => {
  document.body.setAttribute("data-theme", name);
};
